import { StoreAction, StoreConfig } from '@scoring-web/configs/store/store.config';
import main from '@scoring-web/modules/main/stores/main.store';
import user from '@scoring-web/modules/user/stores/user.store';

const stores = { main, user };

// #region Types
type AppStore = typeof stores;
type AppStoreInitial = { [Key in keyof AppStore]: AppStore[Key]['initial'] };
// #endregion

// #region Actions
const actions = {
  reset: (initials?: Partial<AppStoreInitial>) => {
    Object.entries(stores).forEach(([key, store]) => {
      const { actions: storeActions } = store satisfies StoreConfig;
      const passedInitial = initials?.[key as keyof AppStore];

      (storeActions.reset as StoreAction['reset'])?.(passedInitial);
    });
  },
};
// #endregion

const appStore = { ...stores, actions };

export default appStore;
